export const API_URL = process.env.VUE_APP_API_URL;
export const LOGIN_API_URL = process.env.VUE_APP_LOGIN_API_URL;